const IMAGE_MIME_TYPE_REGEX = /^image\/.*/;

const isImage = (mimeType: string): boolean =>
  IMAGE_MIME_TYPE_REGEX.test(mimeType);

export { isImage };
